/** Decodes the HTML entities CMS and WordPress text carries (`&#39;`, `&amp;`, `&#8217;`, …). */
export const decodeHtmlEntities = (str: string): string => {
  if (!str) return '';
  return str
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0?39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/&#8217;/g, '’')
    .replace(/&#8216;/g, '‘')
    .replace(/&#8220;/g, '“')
    .replace(/&#8221;/g, '”')
    .replace(/&#8211;/g, '–')
    .replace(/&#8212;/g, '—')
    .replace(/&hellip;/g, '…')
    .replace(/&#(\d+);/g, (_m, code) => String.fromCharCode(Number(code)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_m, code) => String.fromCharCode(parseInt(code, 16)));
};

/**
 * Plain text from an HTML snippet, the same on the server and in the browser
 * (a DOM-only decode leaves `&#39;` visible in the server-rendered HTML).
 */
export const stripHtml = (html: string): string => decodeHtmlEntities(html.replace(/<[^>]*>/g, '')).trim();
